import { css } from 'lit';

/*
  CSS variables used for elements rendered outside the context of Magento (HTML files, API viewer).
  See https://confluence.hosted-tools.com/display/FAVOGIFTS/Commerce+Engine+integration
*/
export const rootVariablesStyles = css`
  :host {
    --fg-fallback-primary: #505050;
    --fg-fallback-primary--light: #d9e2f1;
    --fg-fallback-primary--dark: #000000;
    --fg-fallback-secondary--light: #fcdde2;
    --fg-fallback-secondary: #ea1f3c;
    --fg-fallback-secondary--dark: #c01827;
    --fg-fallback-tertiary: #d9e2f1;
    --fg-fallback-tertiary--dark: #cedaed;
    --fg-fallback-tertiary--light: #f4f6fb;
    --fg-fallback-hsp-background: #505050;
    --fg-fallback-hsp-color: #ffffff;
    --fg-fallback-gray--100: #f5f5f5;
    --fg-fallback-gray--300: #dedede;
    --fg-fallback-gray--500: #aaaaaa;
    --fg-fallback-gray--600: #8c8c8c;
    --fg-fallback-gray--700: #4f4f4f;
    --fg-fallback-gray--800: #333333;
    --fg-fallback-gray--900: #161616;
    --fg-fallback-error--light: #f8d7da;
    --fg-fallback-error: #f5c6cb;
    --fg-fallback-error--dark: #721c24;
    --fg-fallback-warning--light: #ffe4c7;
    --fg-fallback-warning: #ee7d00;
    --fg-fallback-warning--dark: #9e5300;
    --fg-fallback-cta: #008405;
    --fg-fallback-cta--light: #4ba73b;
    --fg-fallback-cta--dark: #007704;
    --fg-fallback-cta--text: #ffffff;
    --fg-fallback-success: #1c844c;
    --fg-fallback-success--light: #f2f9f3;
    --fg-fallback-success-background: #f2f9f3;
    --fg-fallback-error-background: #fff1f0;
    --fg-fallback-error-content: #cf0513;
    --fg-fallback-config-selected: #f18e49;
    --fg-fallback-config-selected--light: #f4f9f3;
    --fg-fallback-borderradius--xs: 0.25rem;
    --fg-fallback-borderradius--sm: 0.5rem;
    --fg-fallback-borderradius: 0.625rem;
    --fg-fallback-borderradius--xl: 2.5rem;
    --fg-fallback-boxshadow: 0 0 16px rgba(0, 0, 0, 0.15);
    --fg-fallback-boxshadow--xl: 0px 0px 40px rgba(0, 0, 0, 0.3);
    --fg-fallback-usp: #008405;
    --fg-fallback-font-family--serif: 'Arial', sans-serif;
    --fg-fallback-font-family--brand: 'Tahoma', sans-serif;
    --fg-fallback-infobox-content: #003fa3;
    --fg-fallback-infobox-background: #d9e2f1;
    --fg-fallback-text: #333333;
    --fg-fallback-font-size--xs: 0.75rem;
    --fg-fallback-font-size--sm: 0.875rem;
  }
`;
